<template>
  <div v-loading.body="loading" element-loading-text="加载中..." class="app-container" />
</template>

<script>
export default {
  data() {
    return {
      list: [],
      total: 0,
      loading: false
    }
  }
}
</script>
